"use client";

import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import ErrorPage from "@/components/errors/ErrorPage";
import { isBugsnagEnabled, notifyBugsnag } from "@/lib/bugsnag";
import "./error.css";

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    const { resolvedTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!isBugsnagEnabled()) return;
        notifyBugsnag(error, {
            digest: error.digest,
            source: "app-error-boundary",
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isDark = mounted && resolvedTheme === "dark";
    const iconSrc = isDark ? "/errors/500_darkmode.svg" : "/errors/500.svg";

    return (
        <div className="error-500-page">
            <ErrorPage
                code={500}
                background="#eff4ff"
                accent="#0a49a7"
                title="ERROR 500"
                message={
                    <>
                        <div style={{ marginBottom: 8 }}>
                            Something Went Wrong
                        </div>
                        <div>
                            Our server hit a snag. Please try again in a few
                            moments.
                        </div>
                    </>
                }
                icon={
                    <Image
                        src={iconSrc}
                        alt=""
                        aria-hidden="true"
                        width={91}
                        height={91}
                        style={{ display: "block" }}
                    />
                }
                primaryAction={{
                    kind: "retry",
                    label: "Try Again",
                    onRetry: reset,
                }}
                secondaryAction={{
                    kind: "link",
                    label: "Back to Home",
                    href: "/",
                }}
            />
        </div>
    );
}
